import { Image } from '@/components/custom-ui/Image';
import { Button } from '@/components/ui/button';
import useExportExcel from '@/hooks/useExportExcel';

import type {
  ICompanyItemGroupedSupplyInterface,
  ICompanyList,
} from '../../api/CompanyItems.interface';

type Props = {
  items: ICompanyItemGroupedSupplyInterface[];
  startDate: Date | null;
  endDate: Date | null;
  selectedCompany: ICompanyList | null;
};

function ExcelBtn({ items, endDate, selectedCompany, startDate }: Props) {
  const exportToExcel = useExportExcel(
    items,
    `
    تقرير مجمع توريد شركة ${selectedCompany?.Name} من ${startDate?.toLocaleDateString()} الى ${endDate?.toLocaleDateString()}
  .xlsx`,
  );

  return (
    <Button size="sm" variant="outline" onClick={exportToExcel}>
      <Image alt="excel" src="/images/svg/excel.svg" className="ml-2 h-6 w-6" />
      تصدير اكسيل
    </Button>
  );
}

export default ExcelBtn;
